var _rect, _tspan;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 26,
    viewBox: "0 0 18.521 6.8792",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.83296 0 0 .79913 -59.033 -88.18)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70.872,
    y: 110.35,
    width: 22.235,
    height: 8.6083,
    ry: 2.0967,
    fill: "#4950cc"
  })), /*#__PURE__*/React.createElement("text", {
    x: 74.686256,
    y: 115.97654,
    fill: "#ffffff",
    fontFamily: "sans-serif",
    fontSize: "3.712px",
    letterSpacing: "0px",
    strokeWidth: 0.092802,
    wordSpacing: "0px",
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 74.686256,
    y: 115.97654,
    fill: "#ffffff",
    fontFamily: "sans-serif",
    fontWeight: "bold",
    strokeWidth: 0.092802
  }, "ONLINE")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusOnline);
export default __webpack_public_path__ + "static/media/status_online.a7bf8f74b2b8c9947fcdb0ab11dbceff.svg";
export { ForwardRef as ReactComponent };